__turbopack_context__.v({
  "button": "exclusive-offer-module-scss-module__Ze8BRq__button",
  "copyContainer": "exclusive-offer-module-scss-module__Ze8BRq__copyContainer",
  "disclaimer": "exclusive-offer-module-scss-module__Ze8BRq__disclaimer",
  "exclusiveOffer": "exclusive-offer-module-scss-module__Ze8BRq__exclusiveOffer",
  "footer": "exclusive-offer-module-scss-module__Ze8BRq__footer",
  "icon": "exclusive-offer-module-scss-module__Ze8BRq__icon",
  "iconContainer": "exclusive-offer-module-scss-module__Ze8BRq__iconContainer",
  "iconCopyContainer": "exclusive-offer-module-scss-module__Ze8BRq__iconCopyContainer",
  "iconCopyRow": "exclusive-offer-module-scss-module__Ze8BRq__iconCopyRow",
  "image": "exclusive-offer-module-scss-module__Ze8BRq__image",
  "imageContainer": "exclusive-offer-module-scss-module__Ze8BRq__imageContainer",
  "title": "exclusive-offer-module-scss-module__Ze8BRq__title",
});
